import type { SlideProps } from "@/engine/app/offsite-config";

const TILES = [
  { title: "Zendesk eingeführt", text: "Alle Kundenanfragen an einem Ort" },
  { title: "Zählerstand automatisiert", text: "Erster Prozess ohne manuellen Eingriff" },
  { title: "Abschlag, IBAN & mehr", text: "In Arbeit – Abschlag-Automatisierung geht in den nächsten Tagen live" },
  { title: "OBS 2.0 Bestellstrecke", text: "Mit EDL live – als nächstes Commodity- und Non-Commodity-Vertrieb" },
];

export function Slide02Achievements(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Ausgangslage</div>
        <h1 className="deck-title rise rise-2">
          Was wir zusammen <br />
          <span className="accent">geschafft haben</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Als Energievertrieb sind wir hier weiter als viele unserer Größe.
        </p>
      </header>

      <div
        className="deck-cols2"
        style={{ gridTemplateRows: "1fr 1fr", gap: 20 }}
      >
        {TILES.map((t, i) => (
          <div key={t.title} className={`col-card rise rise-${(i % 3) + 4}`}>
            <div className="col-eyebrow">0{i + 1}</div>
            <h4>{t.title}</h4>
            <p>{t.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
